<template>
  <div id="app">
    <router-view/>
    <div class="top">
      <div class="top_box relative" @mouseleave="changeBg">
      <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&amp;uin=1255896643&amp;site=qq&amp;menu=yes"><img alt="找我聊天" title="找我聊天" class="adid_icon" src="../static/img/qq.png" style="display: inline;"></a>
      </div>
      <div class="top_box relative" @mouseenter="changeVal" @mouseleave="changeBg" :class="{box_background:!isChange}" ref="first">
        <a href="javascript:;" v-if="isChange"><img alt="扫二维码" title="扫二维码" class="adid_icon" src="../static/img/icon_sweep.png" style="display: inline;"></a>
        <b v-if="!isChange" style="color: white;font-size: 14px;">扫二维码</b>
        <div class="er_code" v-if="!isChange" ref="first_code">
          <em class="border_sj">◆</em>
          <span class="con_sj">◆</span>
        </div>
        <div class="asid_sha_layer" style="width: 130px;" v-if="!isChange">
          <p class="sweep_img"><img src="../static/img/code.jpg" width="110"></p>
          <p><span style="font-size: 14px;">加我微信</span></p>
        </div>
      </div>
      <div class="top_box relative" @click="backTop()" v-show="backTopShow">
        <a href="javascript:;"><img src="../static/img/icon_back.png" style="display: inline;"></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
    data() {
        return {
            backTopShow:false,
            isChange:true
        }
    },components: {},
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },
    methods: {
        backTop() {
            let back = setInterval(() => {
                if(document.body.scrollTop||document.documentElement.scrollTop){
                    document.body.scrollTop-=100;
                    document.documentElement.scrollTop-=100;
                }else {
                    clearInterval(back)
                }
            });
        },
        handleScroll(){
            if (document.documentElement.scrollTop + document.body.scrollTop > 100) {
                this.backTopShow=true;
            }
            else {
                this.backTopShow=false;
            }
        },
        changeVal(){
            this.isChange = false;
        },
        changeBg(){
            this.$refs.first.style.background = "#AF441E";
            this.isChange = true;
        },
    }
}
</script>

<style scoped>
  .top {
    position: fixed;
    width: 40px;
    bottom: 7%;
    right: 0;
    z-index: 890;
  }
  .top .top_box{
    width: 100%;
    margin-bottom: 3px;
    background: #AF441E;
    text-align: center;
  }
  .top .top_box .box_background{
    background-color: red;
    text-decoration: none;
  }
  .relative {
    position: relative;
    top: 0;
    left: 0;
  }
  .top .top_box a {
    display: block;
    height: 35px;
    padding-top: 5px;
  }
  .top a{
    color: #222;
    text-decoration: none;
    outline: 0;
    cursor: pointer;
  }
  .top .er_code{
    width: 12px;
    height: 40px;
    position: absolute;
    right: 45px;
    bottom: -12px;
    z-index: 100;
  }
  .border_sj {
    color: #ccc;
    font-style: normal;
  }
  .border_sj, .con_sj {
    display: block;
    width: 18px;
    height: 28px;
    font-size: 18px;
    overflow: hidden;
    font-family: SimSun;
  }
  .asid_sha_layer {
    border: 1px solid #ccc;
    background: #fff;
    position: absolute;
    right: 47px;
    bottom: -44px;
  }
  .con_sj {
    color: #fff;
    margin: -28px 0 0 -2px;
  }
  .sweep_img {
    margin: 10px 0px 0px 0px;
  }
  p {
    margin: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue